import React from 'react';
import PropTypes from 'prop-types';
import { isNil } from 'ramda';
import classnames from 'classnames';

export default class CollapsibleDetails extends React.Component {
    static propTypes = {
        id: PropTypes.string,
        summary: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.node])
            .isRequired,
        children: PropTypes.node,
        className: PropTypes.string,
        summaryClassName: PropTypes.string,
        detailsClassName: PropTypes.string,
        onToggle(props, propName) {
            if (!isNil(props.isOpen) && typeof props[propName] !== 'function') {
                return new Error(
                    `${propName} is required to be a function when isOpen is provided.`
                );
            }
            return null;
        },
        // Controlled
        isOpen: PropTypes.bool,
        // Uncontrolled
        initialIsOpen: PropTypes.bool,
    };

    static defaultProps = {
        id: null,
        initialIsOpen: false,
        isOpen: null,
    };

    state = {
        isOpen: this.props.initialIsOpen,
    };

    isControlled = () => {
        return !isNil(this.props.isOpen);
    };

    isOpen = () => {
        if (this.isControlled()) {
            return this.props.isOpen;
        }

        return this.state.isOpen;
    };

    toggle = e => {
        const ignoreEvent =
            ['A', 'BUTTON', 'LABEL', 'INPUT', 'SELECT'].indexOf(e.target.nodeName) !== -1 ||
            (e.target.className && e.target.className).indexOf('fakeSelect') !== -1;

        if (!ignoreEvent) {
            e.preventDefault();

            if (this.isControlled()) {
                if (this.props.onToggle) {
                    this.props.onToggle(!this.props.isOpen);
                }
            } else {
                this.setState(
                    previousState => {
                        return { isOpen: !previousState.isOpen };
                    },
                    () => {
                        if (this.props.onToggle) {
                            this.props.onToggle(this.state.isOpen);
                        }
                    }
                );
            }
        }
    };

    render() {
        const isOpen = this.isOpen();
        const baseClassName = 'collapsibleDetails';
        const classNames = classnames(
            baseClassName,
            {
                open: isOpen,
            },
            this.props.className
        );

        return (
            <div id={this.props.id} className={classNames}>
                <div
                    className={classnames(`${baseClassName}-summary`, this.props.summaryClassName)}
                    onClick={this.toggle}
                >
                    {this.props.summary}
                </div>
                {isOpen && (
                    <div
                        className={classnames(
                            `${baseClassName}-details`,
                            this.props.detailsClassName
                        )}
                    >
                        {this.props.children}
                    </div>
                )}
            </div>
        );
    }
}
